import React, { useState, useEffect } from 'react';
import './JoueurInfo.css';
import { domain } from '../variables';
import axios from 'axios';

function JoueurInfo({player, championnat}) {
    const [performances, setPerformances] = useState([]);
    const [currentOnglet, setCurrentOnglet] = useState(1);
    const [currentPerformance, setCurrentPerformance] = useState(0);

    useEffect(() => {
        if (performances.length == 0) {
            getPerformancesPlayer()
        }
    }, []);

    const getPerformancesPlayer = async () => {
        const link = domain + '/server/getLivescoringResultats.php';
        await axios.post(
            link, 
            {
                joueur: player.joueur,
            }
        ).then(res => {
            const data = res.data;
            if (res.data instanceof Array) {
                setPerformances(data);
            }
        })
    }

    const getBirthday = () => {
        const birthday = new Date(player.birthday).toLocaleDateString('fr-FR');
        if (birthday !== "Invalid Date") {
            return birthday;
        }
        return "";
    }

    const calculateAge = () => {
        var today = new Date();
        var birthDate = new Date(player.birthday);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age || 0;
    }

    const calculateWinrate = () => {
        let countVictory = 0;
        performances.forEach((match) => {
            if (isPlayerWinner(match)) {
                countVictory++;
            }
        })
        return (Math.floor((countVictory / performances.length) * 100)) || 0;
    }

    const isPlayerWinner = (match) => {
        if (match) {
            if (match.statut === "victoire_JA" && getPlayerA(match) === getCurrentPlayerName()) {
                return "winner";
            }
            if (match.statut === "victoire_JB" && getPlayerB(match) === getCurrentPlayerName()) {
                return "winner";
            }
        }
        return '';
    }

    
    const isPlayerWinner2 = (match) => {
        const points = match.total_points;
        const setsPlayerOne = []; const setsPlayerTwo = [];
        let winOne = 0; let winTwo = 0;

        // On sépare les points de chaque sets
        // entre les deux joueurs
        points.split(';').forEach((item) => {
            item.split(',').forEach((separate, index) => {
                if (index == 0) {
                    setsPlayerOne.push(separate);
                }
                else if (index == 1) {
                    setsPlayerTwo.push(separate);
                }
            })
        })

        for (let i = 0; i < setsPlayerOne.length; i++) {
            const value1 = parseInt(setsPlayerOne[i]);
            const value2 = parseInt(setsPlayerTwo[i]);
            if (value1 > value2) {
                winOne++;
            }
            else if (value2 > value1) {
                winTwo++;
            }
        }

        // console.log("SET SET SET SET ET MATCH")
        // console.log(setsPlayerOne + " - " + winOne);
        // console.log(setsPlayerTwo + " - " + winTwo);

        if (winOne == 3 && getPlayerA(match) === getCurrentPlayerName()) {
            return "winner";
        }
        
        if (winTwo == 3 && getPlayerB(match) === getCurrentPlayerName()) {
            return "winner";
        }

        return '';
    }

    const getPlayerA = (match) => {
        if (match) {
            return match.joueur_a.replace('  ', ' ').toUpperCase().trim();
        }
        return "empty_player_avatar";
    }

    const getPlayerB = (match) => {
        if (match) {
            return match.joueur_b.replace('  ', ' ').toUpperCase().trim();
        }
        return "empty_player_avatar";
    }

    const getCurrentPlayerName = () => {
        if (player) {
            return player.joueur.replace('  ', ' ').toUpperCase().trim();
        }
        return "empty_player_avatar";
    }

    const getCorrectOpponent = (match) => {
        if (match !== undefined) {
            if (getPlayerA(match) === getCurrentPlayerName()) {
                return getPlayerB(match);
            }
            return getPlayerA(match);
        }
        return "empty_player_avatar";
    }

    const getTeamOpponent = (match) => {
        if (getPlayerA(match) === getCurrentPlayerName()) {
            return match.club_2_name;
        }
        return match.club_1_name;
    }

    const getDateMatch = (match) => {
        let date = new Date(match.date).toLocaleString('fr-fr', {weekday: "long", year: "numeric", month: "long", day: "numeric"})
        return date.charAt(0).toUpperCase() + date.slice(1);
    } 

    const handleNextMatch = (e, previousOrNext = 0) => {
        e.preventDefault();
        // 0 : previous / 1 : next
        // S'il reste des matchs à consulter
        // alors on passe au suivant
        if (previousOrNext == 1) {
            if (currentPerformance < (performances.length-1)) {
                setCurrentPerformance(currentPerformance + 1);
            }
        }
        else {
            if (currentPerformance > 0) {
                setCurrentPerformance(currentPerformance - 1);
            }
        }
    }

    const handleSetOnglet = (step) => {
        const newOnglet = currentOnglet + step;
        setCurrentOnglet(newOnglet);
        if (newOnglet == 2) {
            // on récupère les performances du joueur
            if (performances.length == 0) {
                getPerformancesPlayer()
            }
        }
    }


    return ( 
        <div className="joueur_info_component">
            {/* AVATAR DU JOUEUR */}
            <div className="joueur_info_avatar">
                <img 
                    className="player_picture"
                    src={"./images/players/" + getCurrentPlayerName() + ".png"} 
                    alt="" 
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null; 
                        currentTarget.className = "empty_player_avatar";
                        currentTarget.src="./images/players/empty_player_avatar.png";
                    }}
                />
            </div>
            {
                currentOnglet == 1 &&
                // Informations du JOUEUR
                <div className={"joueur_info_description " + championnat}>
                    <div className="joueur_info_description_left">
                        <div
                            style={{display: 'flex', alignItems: 'center', gap: 15}}
                        >
                            <span className="joueur_info_name">
                                {player.joueur}
                                <img 
                                    className="joueur_info_flag"
                                    src={"./images/atlas_flags/"+player.code_pays.toLowerCase()+"-flag.jpg"}
                                    alt="flag" 
                                    title={player.nationalite}
                                    onError={({ currentTarget }) => {
                                        currentTarget.onerror = null;
                                        currentTarget.className="flag_none"
                                        currentTarget.src="./images/atlas_flags/none.jpg";
                                    }}
                                />
                            </span>
                        </div>
                        {/* Informations du joueur */}
                        <div>
                            {
                                getBirthday() !== "" &&
                                <div>
                                    <span className="joueur_info_subcategories">Âge : </span>
                                    <span className="joueur_info_details">{calculateAge() + " - (" + getBirthday()+")"}</span>
                                </div>
                            }
                            <div>
                                <span className="joueur_info_subcategories">Style : </span>
                                <span className="joueur_info_details">{player.style}</span>
                            </div>
                        </div>
                    </div>
                    <div className="joueur_info_separator"></div>
                    <div className="joueur_info_description_right">
                        {/* Classement */}
                        <div className="joueur_info_classement_container">
                            <div className='joueur_info_classement'>
                                <span style={{fontSize: 16, fontFamily: 'Roboto', whiteSpace: 'nowrap'}}>Classement Mondial :</span>
                                <span className="joueur_info_span_classement">
                                    <span style={{color: 'var(--yellow-color)'}}>#</span>
                                    {
                                        player.classement_mondial > 0 && player.classement_mondial
                                        ||
                                        "NC"
                                    }
                                </span>
                            </div>
                            <div className='joueur_info_classement'>
                                <span  style={{fontSize: 16, fontFamily: 'Roboto', whiteSpace: 'nowrap'}}>Classement Français :</span>
                                <span className="joueur_info_span_classement">
                                    <span style={{color: 'var(--yellow-color)'}}>#</span>
                                    {player.classement}
                                </span>
                            </div>
                        </div>
                        {/* Performances */}
                        <div className="perf_container" style={{display: 'flex', flexDirection: 'column', alignItems: 'end', width: '100%'}}>
                            {
                                performances.length > 0 &&
                                <span style={{fontSize: 18, fontFamily: 'Roboto'}}>
                                    <span className="joueur_info_subcategories" style={{marginRight: 5, fontWeight: 'bold'}}>
                                        {calculateWinrate()}%
                                    </span>
                                    de victoires
                                </span>
                                ||
                                <span style={{fontSize: 18, fontFamily: 'Roboto'}}>
                                    0 match disputé
                                </span>
                            }
                            {
                                performances.length > 0 &&
                                <div className="joueur_info_next" onClick={()=>handleSetOnglet(1)}>{"Voir les performances >"}</div>
                                ||
                                <div className="joueur_info_nothing">Aucune performance disponible</div>
                            }
                            
                        </div>
                    </div>
                </div>
                || currentOnglet == 2 &&
                <div className={"joueur_info_performances_container " + championnat}>
                    <span className='span_perf'>Performances de {player.joueur}</span>
                    {/* Cette partie est réservée au résultat des matchs */}
                    {
                            performances.length > 0 &&
                            performances.slice(currentPerformance, currentPerformance + 1).map((match, index) => {
                                return (
                                    <div key={index} style={{display: 'flex', width: '100%', justifyContent: "space-between", alignItems: 'center'}}>
                                        <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                                            <div className='subtitles_performances'>
                                                {/* Date du match */}
                                                <span style={{fontSize: 12, fontFamily: 'Roboto', textShadow: '1px 1px 3px black'}}>{getDateMatch(match)}</span>
                                                <span className="performances_separator">|</span>
                                                {/* Nom de l'opposant */}
                                                <span style={{fontSize: 12, fontFamily: 'Roboto', textShadow: '1px 1px 3px black'}}>VS {getCorrectOpponent(match)} - {getTeamOpponent(match)}<span></span></span>
                                                <span  className="performances_separator">|</span>
                                                {/* Message victoire ou défaite */}
                                                <span
                                                    style={{fontSize: 12, textShadow: '1px 1px 3px black', fontFamily: 'Roboto', color: isPlayerWinner(match) ? "lightgreen" : 'red'}}
                                                >
                                                    {isPlayerWinner(match) ? "Victoire" : "Défaite"}
                                                </span>
                                            </div>
                                            {/* SETS SETS SETS ET MATCH */}
                                            <div className="joueur_info_perf">
                                                {
                                                    match.total_points.split(';').map((item) => {
                                                        return (
                                                            <div className="joueur_info_scores">
                                                                <span className={getCurrentPlayerName() === getPlayerA(match) ? "pj_scores_p" : ""}>{item.split(',')[0]}</span>
                                                                <span className={getCurrentPlayerName() === getPlayerB(match) ? "pj_scores_p" : ""}>{item.split(',')[1]}</span>
                                                            </div>
                                                        )
                                                    }) 
                                                }
                                            </div>
                                            {/* Bouton pour aller au match suivant */}
                                            <div className="joueur_match_arrow">
                                                {
                                                    currentPerformance > 0 &&
                                                    <span 
                                                        className="pj_match_previous"
                                                        onClick={(e)=>handleNextMatch(e)}
                                                    >
                                                        {"<"} Match précédent 
                                                    </span>
                                                }
                                                {
                                                    currentPerformance < (performances.length - 1) &&
                                                    <span 
                                                        className="pj_match_next"
                                                        onClick={(e)=>handleNextMatch(e, 1)}
                                                    >
                                                        Match suivant {">"}
                                                    </span>
                                                }
                                            </div>
                                            <span className="joueur_info_back" style={{width: 'fit-content'}} onClick={()=>handleSetOnglet(-1)}>{"< Retour"}</span>
                                        </div>
                                    </div>
                                )
                            })
                        } 
                </div>
            }
            
        </div>
    );
}

export default JoueurInfo;